import React from 'react';
import styles from "./styles.module.css";
import Navbar from './navbar';

const Menu: React.FC = (props) => {

    return (
        <div className={styles.containermenu}>
            <Navbar />
        </div>

    )

}


export default Menu;